import type { Row, SectionDef } from '../types'

function slug(value: string, max = 16): string {
  return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase().replace(/[^A-Z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, max)
}
function unitCode(row: Row): string {
  const direct = String(row.unit_code || '').match(/U\d+/i)?.[0]
  if (direct) return direct.toUpperCase()
  const match = String(row.unit || '').match(/(?:UNIDAD\s*)?(\d+)/i)
  return match ? `U${match[1]}` : slug(row.unit || 'UX', 6)
}
function oaCode(row: Row): string {
  const match = String(row.oa || '').match(/OA\s*0?(\d+)/i)
  return match ? `OA${String(Number(match[1])).padStart(2, '0')}` : 'OA00'
}
function nextNumber(prefix: string, rows: Row[], keyField: string): string {
  const values = rows.map((row) => String(row[keyField] || '')).filter((id) => id.startsWith(prefix))
  const maximum = values.reduce((max, id) => Math.max(max, Number(id.match(/(\d+)(?:-V\d+)?$/)?.[1] ?? 0)), 0)
  return String(maximum + 1).padStart(3, '0')
}

export function suggestId(section: SectionDef, row: Row, rows: Row[]): string {
  if (section.id === 'students') return `EST-${slug(row.course || '6', 6)}-${slug(row.first_name || 'NOMBRE', 8)}`
  if (section.id === 'sessions') {
    const prefix = `SES-${unitCode(row)}-${oaCode({ oa: String(row.selected_oas || '').split(/[|;]/)[0] })}-`
    return `${prefix}${nextNumber(prefix, rows, section.keyField)}`
  }
  if (section.id === 'sources') {
    const prefix = `FUE-${unitCode(row)}-${oaCode(row)}-`
    return `${prefix}${nextNumber(prefix, rows, section.keyField)}`
  }
  if (section.id === 'materials') {
    const prefix = `MAT-${unitCode(row)}-${oaCode(row)}-`
    return `${prefix}${nextNumber(prefix, rows, section.keyField)}`
  }
  if (section.id === 'topics') {
    const prefix = `CAT-${unitCode(row)}-`
    return `${prefix}${nextNumber(prefix, rows, section.keyField)}`
  }
  const prefix = `PREG-${unitCode(row)}-${oaCode(row)}-`
  return `${prefix}${nextNumber(prefix, rows, section.keyField)}`
}

export function nextVersion(row: Row): string {
  const current = Number(String(row.version || 'V1').replace(/\D/g, '')) || 1
  return `V${current + 1}`
}

export function validId(value: string): boolean {
  return /^[A-Z0-9]+(?:-[A-Z0-9]+)*$/.test(value)
}
